import React, { FC } from 'react';
import { BodyTextSmall, FlexDynamic } from '@minecraft.atoms';
import { useTranslation } from '@blocs.i18n';
import { SearchMediaResultFragment } from '@minecraft.graphql-operations';
import Icon from '@minecraft.icon';

type LockedMediaOverlayProps = {
  media: SearchMediaResultFragment;
  size?: 'sm' | 'lg';
};

export const LockedMediaOverlay: FC<LockedMediaOverlayProps> = ({ media, size }) => {
  const { t } = useTranslation();

  if (media?.mediaStatus?.code !== 'ARCHIVED' && !media?.isLocked) {
    return null;
  }

  return (
    <FlexDynamic
      data-testid="locked-overlay-container"
      direction="row"
      className="cn_absolute"
      w="full"
      alignItems="center"
      justifyContent="center"
      gap="2"
      top={0}
      bottom={0}
      bgColor="mediaBankLockedOverlay"
      bgOpacity={0.5}
    >
      <Icon name="lock" themeColor="inverted" width={1} height={1} aria-label={t('common:mediaStatus.locked')} />
      {(!size || size === 'lg') && (
        <BodyTextSmall color="inverted" fontWeight="bold">
          {t('common:mediaStatus.locked')}
        </BodyTextSmall>
      )}
    </FlexDynamic>
  );
};
